<h1 mat-dialog-title>{{ data.dialogTitle }}</h1>
<div mat-dialog-content>
  <form class="edit-subscription-price-dialog-form">
    <mat-form-field *ngIf="data.isNew">
      <mat-label>Subscription Type</mat-label>
      <mat-select
        name="data.subscriptionTypeId"
        [(ngModel)]="data.subscriptionTypeId"
        (selectionChange)="selectedSubTypeChanged()"
      >
        <mat-option
          *ngFor="let subTypes of data.interactSubTypes"
          [value]="subTypes.interactSubTypeId"
          >{{ subTypes.interactSubTypeName }}</mat-option
        >
      </mat-select>
    </mat-form-field>
    <ng-conainer *ngIf="!data.isNew">
      <mat-label>Subscription Type</mat-label>
      <div>
        <ng-container *ngFor="let subTypes of data.interactSubTypes">
          <ng-container
            *ngIf="subTypes.interactSubTypeId == data.subscriptionTypeId"
          >
            {{ subTypes.interactSubTypeName }}
          </ng-container>
        </ng-container>
      </div>
    </ng-conainer>
    <br />
    <mat-form-field *ngIf="data.isNew">
      <mat-label>Level</mat-label>
      <mat-select
        name="data.subscriptionLevelId"
        [(ngModel)]="data.subscriptionLevelId"
      >
        <mat-option
          *ngFor="let subLevel of filteredSubLevels"
          [value]="subLevel.interactSubLevelId"
          >{{ subLevel.description }}</mat-option
        >
      </mat-select>
    </mat-form-field>
    <ng-conainer *ngIf="!data.isNew">
      <mat-label>Level</mat-label>
      <div>
        <ng-container *ngFor="let subLevel of data.interactSubLevels">
          <ng-container
            *ngIf="
              subLevel.interactSubLevelId == data.subscriptionLevelId &&
              subLevel.interactSubTypeId == data.subscriptionTypeId
            "
          >
            {{ subLevel.description }}
          </ng-container>
        </ng-container>
      </div>
    </ng-conainer>
    <br />
    <mat-form-field *ngIf="data.isNew">
      <mat-label>Period Type</mat-label>
      <mat-select name="data.periodTypeId" [(ngModel)]="data.periodTypeId">
        <mat-option
          *ngFor="let subPeriod of data.subPeriodTypes"
          [value]="subPeriod.periodTypeId"
          >{{ subPeriod.description }}</mat-option
        >
      </mat-select>
    </mat-form-field>
    <ng-conainer *ngIf="!data.isNew">
      <mat-label>Period Type</mat-label>
      <div>
        <ng-container *ngFor="let subPeriod of data.subPeriodTypes">
          <ng-container *ngIf="subPeriod.periodTypeId == data.periodTypeId">
            {{ subPeriod.description }}
          </ng-container>
        </ng-container>
      </div>
    </ng-conainer>
    <br />
    <mat-form-field>
      <mat-label>Price</mat-label>
      <input
        matInput
        name="data.price"
        type="number"
        [(ngModel)]="data.price"
      /> </mat-form-field
    ><br />
    <mat-form-field>
      <mat-label>Custom Terms (NET 15 if empty, full terms otherwise: NET 45, --NOT-- 45)</mat-label>
      <input
        matInput
        name="data.customTerms"
        [(ngModel)]="data.customTerms"
      /> </mat-form-field
    ><br />
    <mat-form-field>
      <mat-label>Tax (In Decimal: 0.0725 = 7.25%, blank = no tax)</mat-label>
      <input
        matInput
        type="number"
        step="0.00001"
        name="data.tax"
        [(ngModel)]="data.tax"
      /> </mat-form-field
    ><br />
    <ng-container>
      <mat-checkbox name="data.suppressInvoice" [(ngModel)]="data.suppressInvoice">Suppress Invoice?</mat-checkbox>
    </ng-container><br />
    <ng-container *ngIf="!data.isNew">
      <mat-checkbox name="data.clearProposal" [(ngModel)]="data.clearProposal">Clear Proposal?</mat-checkbox>
    </ng-container>
    <br />
    <ng-container>
      <mat-label>Proposal File: ({{ data.proposalFile?.name }})</mat-label>
      <input
        type="file"
        id="inputFile"
        (change)="handleFileInput($event.target.files)"
      />
    </ng-container>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="onConfirmClick()">
    Save Subscription Price
  </button>
  <button mat-raised-button (click)="onCancelClick()">Cancel</button>
</div>
